// Plain module (no "use server"): safe on client and server.

const LEAK = /prisma|invocation|\n\s+at |ECONN|ETIMEDOUT|ENOTFOUND|SQL|P\d{4}\b|Unique constraint|Foreign key|constraint failed|Cannot read prop|undefined|\bnode_modules\b|\.tsx?:\d+|Server Components render/i;

export const GENERIC_ERROR = "Something went wrong. Please try again.";

/** Message that is safe to show a user; `fallback` when the error is not an Error, is empty, too long or leaks internals. */
export function userMessage(err: unknown, fallback: string = GENERIC_ERROR): string {
  if (!(err instanceof Error)) return fallback;
  const m = err.message.trim();
  if (!m || m.length > 300 || LEAK.test(m)) return fallback;
  return m;
}

/** Zod issues as `{ field: message }` (first issue per field wins; fieldless issues go under "form"). */
export function zodErrors(e: { issues: { path: PropertyKey[]; message: string }[] }): Record<string, string> {
  const out: Record<string, string> = {};
  for (const i of e.issues) out[String(i.path[0] ?? "form")] ??= i.message;
  return out;
}

/** Log and swallow: for side effects (search index, notifications, email) that must not fail the action. */
export function bestEffort(p: Promise<unknown>, what: string) {
  return p.catch((err) => console.error(`Failed to ${what}:`, err));
}
